import { Autocomplete, TextField } from "@mui/material";
import { FC, useMemo } from "react";
import { Control, Controller } from "react-hook-form";

import { useGetCryptors } from "@/api/cryptor.api";
import { UserFormValues } from "@/pages/user/user-form";

interface UserCryptorDraftAccessSelectProps {
  control: Control<UserFormValues>;
}

const UserCryptorDraftAccessSelect: FC<UserCryptorDraftAccessSelectProps> = ({
  control,
}) => {
  const { data: cryptors } = useGetCryptors();

  const options = useMemo(
    () => cryptors?.map((cryptor) => ({ id: cryptor.id })) || [],
    [cryptors],
  );

  return (
    <Controller
      control={control}
      name="cryptorsDraftAccess"
      render={({ field, fieldState }) => {
        return (
          <Autocomplete
            multiple
            id="user-cryptor-draft-access-select"
            options={options}
            getOptionLabel={(option) =>
              cryptors?.find((cryptor) => cryptor.id === option.id)?.name || ""
            }
            value={field.value.flatMap((entry) =>
              typeof entry === "number" ? [{ id: entry }] : [entry],
            )}
            onChange={(_event, data) => field.onChange(data)}
            onBlur={field.onBlur}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label="Acces aux cryptors en brouillon"
                placeholder="Cryptor"
                error={fieldState.invalid}
              />
            )}
          />
        );
      }}
    />
  );
};

export default UserCryptorDraftAccessSelect;
